































import Vue from 'vue'
import Modal from '@/components/shared/atoms/Modal'
import SupportContentContainer from '@/containers/Support/Content'
import { routes } from '@/router'

export default Vue.extend({
  components: {
    Modal,
    SupportContentContainer
  },
  data() {
    return {
      showFAQModal: false
    }
  },
  computed: {
    isDevMode(): boolean {
      return process.env.NODE_ENV === 'local' || process.env.NODE_ENV === 'development'
    }
  },
  mounted() {
    // console.log('inspecting conig file')
    // console.log(process.env.APP_CONFIG)
    if (process.env.RELEASE_VERSION) {
      console.log('RELEASE VERSION: ' + process.env.RELEASE_VERSION)
    }
  },
  methods: {
    addQueue() {
      this.$toastRepository.addQueue({
        text: `${new Date()}`,
        type: 'success'
      })
    },
    copyState() {
      const state = JSON.stringify(this.$store.state, null, '\t')
      this.copyToClipBoard(state, 'Copied Vuex snapshot!')
    },
    copyRoutes() {
      const paths = routes.map(r => r.path)

      this.copyToClipBoard(JSON.stringify(paths, null, '\t'), 'Copied all routes!')
    },
    throwError() {
      throw new Error('This is a test error thrown by our debug menu!')
    },
    copyToClipBoard(str: string, msg: string) {
      const hiddenArea = this.$refs['hiddenArea'] as HTMLInputElement
      if (!hiddenArea) return

      hiddenArea.textContent = str
      hiddenArea.select()
      document.execCommand('copy')
      alert(msg)
      hiddenArea.textContent = ''
    }
  }
})
